'use client';
import CheckCircleFill from '@/components/icons/CheckCircleFill';
import Cross from '@/components/icons/Cross';
import ErrorFill from '@/components/icons/ErrorFill';
import { Toast as ToastType } from '@/types/Toast';
import { FC, useEffect, useRef } from 'react';
import styles from './styles.module.scss';

export type ToastProps = ToastType & {
  onClose?: () => void;
};

const Toast: FC<ToastProps> = ({ children, toastType, onClose, delay = 5 }) => {
  const timeoutId = useRef<NodeJS.Timeout>(undefined);

  const handleClose = () => {
    clearInterval(timeoutId.current);
    onClose && onClose();
  };

  useEffect(() => {
    if (delay < 0) return;

    timeoutId.current = setTimeout(() => {
      handleClose();
    }, delay * 1000);
    return () => {
      clearTimeout(timeoutId.current);
    };
  }, []);

  return (
    <div className={`${styles.container} ${styles[toastType]}`}>
      {(() => {
        switch (toastType) {
          case 'error':
            return <ErrorFill className={styles.icon} />;
          case 'success':
            return <CheckCircleFill className={styles.icon} />;
          default:
            return null;
        }
      })()}

      {typeof children === 'string' ? (
        <p className={`bold ${styles.content}`}> {children}</p>
      ) : (
        children
      )}
      <Cross className={styles.cross} onClick={handleClose} />
    </div>
  );
};

export default Toast;
